export default __webpack_public_path__ + "static/media/MotorsImg.46c325c0.jpg";